import { HttpMethods, makeRequest } from '../helpers/http.helper';
import type { DeliveryDetails } from '../types/delivery.type';

interface GenericResponse<T> {
  result: T;
}

export async function getDeliveryByPickupOrder(pickupOrderId: string): Promise<DeliveryDetails> {
  const response = (await makeRequest({
    url: `/delivery/pickup-order/${pickupOrderId}`,
    method: HttpMethods.GET,
  })) as GenericResponse<DeliveryDetails>;
  return response.result;
}
